import './topNavbar.css';
import "../../../node_modules/bootstrap-icons/font/bootstrap-icons.css";
import { Container, Nav, Navbar, NavDropdown, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import { useAppKeycloak } from '../../keycloak/keycloakUtils';
import appConfig from '../../config/config';
import { useSelector } from 'react-redux';

export default function TopNavbar() {
    const { t } = useTranslation();
    const { keycloak } = useAppKeycloak();
    const logoUrl = `${appConfig.ROUTER_BASE_PATH}/Logo_Healthyland.png`;
    const logoTitleUrl = `${appConfig.ROUTER_BASE_PATH}/HealthyLand_Title.png`;
    const homepageUrl = `${appConfig.APP_PATH}`;
    const person = useSelector(state => state.person?.person);
    const loading = useSelector(state => state.person?.loading);
    const isAuthenticated = keycloak?.authenticated;
    const userDisplay = loading || !person
        ? "Loading... "
        : t('topnavbar:messages.welcome', {
            username: person.name || '',
            usersurname: person.surname || ''
        });

    // Mappatura delle azioni del menu
    const menuActions = {
        toolbox: () => {
            window.location.href = appConfig.TOOLBOX_URL;
        },
        dashboard: () => {
            window.location.href = appConfig.DASHBOARD_URL;
        },
        logout: () => { keycloak.logout({ redirectUri: `${appConfig.APP_PATH}` }); },
        default: () => console.log('Azione non definita'), // Azione predefinita
    };

    // Gestore dinamico delle azioni
    const handleMenuClick = (action) => {
        const executeAction = menuActions[action] || menuActions.default; // Se l'azione non è definita, usa quella predefinita
        executeAction();
    };

    return (
        <Navbar collapseOnSelect>
            <Container className='container-topnavbar' fluid>
                <Row className='row-topnavbar align-items-center'>
                    <Col className='col-logo d-flex align-items-center'>
                        <Navbar.Brand href={homepageUrl}><img className='logo-healthyland' src={logoUrl} alt='Healthyland' /></Navbar.Brand>
                    </Col>
                    <Col className='col-title d-none d-md-flex justify-content-center align-items-center'>
                        <img
                            className='healthyland-title'
                            src={logoTitleUrl}
                            alt='Healthyland'
                        />
                    </Col>
                    <Navbar.Toggle />
                    <Col className='col-menu'>
                        <Navbar.Collapse className='justify-content-end'>
                            {isAuthenticated ? (

                                <Nav>
                                    <NavDropdown
                                        title=
                                        {<>
                                            <span className="me-2">{userDisplay}</span>
                                            <i className="bi bi-person user-icon" />
                                        </>
                                        }
                                        align="end" style={{ marginRight: '15px' }}>
                                        <NavDropdown.Item onClick={() => handleMenuClick('toolbox')}>{t("topnavbar:labels.topNavbarDropdown.toolbox")}</NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => handleMenuClick('dashboard')}>{t("topnavbar:labels.topNavbarDropdown.dashboard")}</NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => handleMenuClick('logout')}>{t("topnavbar:labels.topNavbarDropdown.logout")}</NavDropdown.Item>
                                    </NavDropdown>
                                </Nav>
                            ) : (
                                <Nav>
                                    <Nav.Link className="guest-message-link">
                                        {t("topnavbar:messages.guest")}
                                    </Nav.Link>
                                </Nav>
                            )}
                            <Nav><LanguageSelector /></Nav>
                        </Navbar.Collapse>
                    </Col>
                </Row>
            </Container>
        </Navbar>
    );
}